import React, { useContext, useEffect, useState } from "react";
import {
  getProductMaster,
  deleteProductMaster,
  updateProductMaster,
  apiClient,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { EditProductMaster } from "./pform";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate, getStoredEntriesPerPage } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation, useNavigate } from "react-router-dom";

const displayLimit = (limit) => {
  if (!limit) return '1 Kg';
  const str = String(limit).toLowerCase();
  if (str.includes('kg')) return limit;
  return `${limit} Kg`;
};

const ProductMaster = () => {
  const { showLoader, hideLoader, shopItem, UserItem, warehouse } = useContext(WarehouseContext);

  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  // const { showLoader, hideLoader } = useContext(WarehouseContext);
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    cat_id: "",
    status: "1",
  });
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [addOrEdit, setAddOrEdit] = useState(true);
  const [isDuplicate, setIsDuplicate] = useState(false);

  const [deleteID, setDeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(getStoredEntriesPerPage(10));

  const [searchText, setSearchText] = useState("");
  const [inputSearch, setInputSearch] = useState("");

  const handledeletemodel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  };

  const fetchProducts = async (page = currentPage, text = searchText, limit = entriesPerPage) => {
    showLoader();
    try {
      const params = {
        shop_id: shopItem?.shop_id || "0",
        // ware_id: warehouse?.id || "1",
        page,
        page_size: limit,
        search: text,
      };

      const response = await getProductMaster(params);

      if (response.data && response.data.data) {
        const sortedData = [...response.data.data].sort((a, b) =>
          (a.title || "").localeCompare(b.title || "", undefined, { sensitivity: 'base' })
        );
        setProducts(sortedData);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching product master data:", error);
      toast.error("Failed to fetch products");
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setSearchText(inputSearch);
      setCurrentPage(1);
    }, 400);

    return () => clearTimeout(delayDebounceFn);
  }, [inputSearch]);

  useEffect(() => {
    fetchProducts(currentPage, searchText, entriesPerPage);
  }, [currentPage, searchText, entriesPerPage]);

  const generateCopyTitle = (originalTitle, existingProducts) => {
    const baseTitle = (originalTitle || "").replace(/\s*\(Copy(\s+\d+)?\)$/i, "").trim();
    let candidate = `${baseTitle} (Copy)`;
    let counter = 2;
    const existingTitles = (existingProducts || []).map(p => (p.title || "").toLowerCase().trim());

    while (existingTitles.includes(candidate.toLowerCase().trim())) {
      candidate = `${baseTitle} (Copy ${counter})`;
      counter++;
    }
    return candidate;
  };

  const openAddModal = () => {
    setAddOrEdit(true);
    setIsDuplicate(false);
    setSelectedProduct(null);
    setShowEditModal(true);
  };

  const openEditModal = (prod) => {
    setSelectedProduct(prod);
    setAddOrEdit(false);
    setIsDuplicate(false);
    setShowEditModal(true);
  };

  const openDuplicateModal = (prod) => {
    const duplicateTitle = generateCopyTitle(prod.title, products);
    setSelectedProduct({
      ...prod,
      title: duplicateTitle,
    });
    setAddOrEdit(true);
    setIsDuplicate(true);
    setShowEditModal(true);
  };

  const handleDelete = async () => {
    if (!deleteID) {
      toast.error("No product selected to delete");
      return;
    }

    try {
      await deleteProductMaster(deleteID);
      showDeletemodel(false);
      toast.success("Product deleted");
      fetchProducts(currentPage);
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Error deleting product");
    }
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const activateProduct = async (value) => {
    showLoader();
    try {
      const payload = {
        ...value,
        status: "0",
      };
      await updateProductMaster(value?.id, payload);
      fetchProducts(currentPage);
      toast.success("Product Activated");
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    } finally {
      hideLoader();
    }
  };

  const handleNavigateToIngredients = (product) => {
    navigate(`/ingredients/${product.product_id}`, {
      state: {
        productName: product.title,
        productData: product
      }
    });
  };

  const handleNavigateToProductDetails = (product) => {
    navigate(`/product-details/${product.product_id}`, {
      state: {
        productName: product.title,
        productData: product
      }
    });
  };

  const handleNavigateToProcess = (product) => {
    navigate(`/process/${product.product_id}`, {
      state: {
        productName: product.title,
        productData: product
      }
    });
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6
            className="mb-0 text-uppercase"
            style={{ fontFamily: "poppins" }}
          >
            Product  List
          </h6>
          {!readonly && (
            <button
              type="button"
              onClick={() => openAddModal()}
              className="btn btn-primary mb-0"
              style={{ fontFamily: "poppins" }}
            >
              Add Product
            </button>
          )}
        </div>
        <hr className="mt-1" />

        <div className="card">
          <div className="card-body">
            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
              <div
                className="d-flex position-relative"
                style={{ width: "100%" }}
              >
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  value={inputSearch}
                  onChange={(e) => setInputSearch(e.target.value)}
                />
                <img
                  src="/assets/images/icons/search.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "18px",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table
                className="table table-striped table-sm table-bordered align-middle"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "80px" }}>S.No</th>
                    <th style={{ width: "100px" }}>Image</th>
                    <th>Title</th>
                    <th style={{ width: "120px" }}>Limit</th>
                    <th style={{ width: "180px" }}>Category</th>
                    {/* <th>SubCategory</th> */}
                    {!readonly && <th style={{ width: "120px" }}>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {products.map((prod, index) => (
                    <tr key={prod.id}>
                      <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                      <td>
                        <img
                          src={prod.product_image
                            ? (prod.product_image.startsWith("http")
                                ? prod.product_image
                                : `${apiClient.defaults.baseURL}${prod.product_image.startsWith("/") ? "" : "/"}${prod.product_image}`)
                            : "/assets/images/product_placeholder.png"}
                          alt={prod.title}
                          onError={(e) => {
                            e.target.src = "/assets/images/product_placeholder.png";
                          }}
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "cover",
                            borderRadius: "4px",
                            display: "block",
                            margin: "0 auto",
                          }}
                        />
                      </td>
                      <td>{prod.title}</td>
                      <td>{displayLimit(prod.weight_limit)}</td>
                      <td>{prod.category_name}</td>
                      {/* <td>{prod.subcategory_name}</td> */}
                      {!readonly && (
                        <td>
                          {/* Duplicate Button (Hidden) */}
                          {/* <span
                            onClick={() => openDuplicateModal(prod)}
                            className="cursor-pointer"
                            title="Duplicate Product & Ingredients"
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", verticalAlign: "middle" }}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#0284c7"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                            </svg>
                          </span>
                          &nbsp;&nbsp;&nbsp; */}

                          {/* Edit Button */}
                          <img
                            src="/assets/images/icons/edit.png"
                            onClick={() => openEditModal(prod)}
                            height="16px"
                            alt="Edit"
                            className="cursor-pointer"
                            title="Edit Product"
                            style={{ cursor: "pointer", verticalAlign: "middle" }}
                          />
                          &nbsp;&nbsp;&nbsp;

                          {/* Delete Button */}
                          <img
                            src="/assets/images/icons/delete.png"
                            onClick={() => handledeletemodel(prod.product_id)}
                            height="16px"
                            alt="Delete"
                            className="cursor-pointer"
                            title="Delete Product"
                            style={{ cursor: "pointer", verticalAlign: "middle" }}
                          />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                entriesPerPage={entriesPerPage}
                onEntriesPerPageChange={(val) => {
                  setEntriesPerPage(val);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      <EditProductMaster
        showModal={showEditModal}
        setShowModal={setShowEditModal}
        setSelectedProduct={setSelectedProduct}
        fetchProducts={() => fetchProducts(currentPage)}
        selectedProduct={selectedProduct}
        AddorEdit={addOrEdit}
        setCurrentPage={setCurrentPage}
        isDuplicate={isDuplicate}
        setIsDuplicate={setIsDuplicate}
      />
    </div>
  );
};

export default ProductMaster;